
// ithelps
jQuery(document).ready(function() {
  // stock display at products
  ////
  // 1. display defautl stock
  var defaultProduct = jQuery('.variant_sku').text();
  //console.log('Variant: '+defaultProduct);
  jQuery('.mit-stock-'+defaultProduct).show();
  
  jQuery('.swatch-element label').on('click',function() {
    setTimeout(function() {
      var defaultProduct = jQuery('.variant_sku').text();	
      jQuery('.mit-stock').hide();
      jQuery('.mit-stock-'+defaultProduct).show();
    }, 500);
    
  });
  
  jQuery('.selector-wrapper select').on('change',function() {
    setTimeout(function() {
      var defaultProduct = jQuery('.variant_sku').text();	
      jQuery('.mit-stock').hide();
      jQuery('.mit-stock-'+defaultProduct).show();
    }, 500);
    
  });
  
});